module.exports = __webpack_public_path__ + "img/caseB.b2edf95f.jpg";